// ============================================================
// EcomChief Bundle Builder — Version 2.0 — Award-Level UI
// Redesigned with DM Sans + DM Serif Display typography,
// spring animations, premium card system, archetype presets,
// and full EcomChief brand system (#0d1b2a, #2563eb, #10b981)
// ============================================================

(function () {
"use strict";

// ── PRODUCTS ──────────────────────────────────────────────
const PRODUCTS = [
  {id:"ds-001",name:"Pet Supplies Store",short:"Pet Supplies",cat:"dropshipping",price:99,handle:"pet-supplies-dropshipping-business-for-sale",bullets:["Fully stocked catalog","Supplier connected","No inventory needed"]},
  {id:"ds-002",name:"Electronics Store",short:"Electronics",cat:"dropshipping",price:99,handle:"electronics-dropshipping-business-for-sale",bullets:["Tech niche","Trending products","Ready to launch"]},
  {id:"ds-003",name:"Auto Accessories Store",short:"Auto Accessories",cat:"dropshipping",price:99,handle:"auto-accessories-dropshipping-business",bullets:["High-margin niche","Supplier network","SEO-ready"]},
  {id:"ds-004",name:"Women's Fashion Store",short:"Women's Fashion",cat:"dropshipping",price:99,handle:"womens-fashion-dropshipping-business-for-sale",bullets:["Boutique brand","Social-ready","Full range"]},
  {id:"ds-005",name:"Fitness & Gym Store",short:"Fitness & Gym",cat:"dropshipping",price:99,handle:"fitness-dropshipping-business-for-sale",bullets:["Growing niche","Workout gear","Supplier ready"]},
  {id:"ds-006",name:"Health Supplements Store",short:"Health Supps",cat:"dropshipping",price:99,handle:"health-supplements-dropshipping-business",bullets:["High AOV","Repeat buyers","Premium brand"]},
  {id:"ds-007",name:"Dollar Discount Store",short:"Dollar Discount",cat:"dropshipping",price:99,handle:"dollar-discount-dropshipping-business",bullets:["Mass market","High volume","Broad catalog"]},
  {id:"ds-008",name:"Men's Grooming Store",short:"Men's Grooming",cat:"dropshipping",price:99,handle:"mens-grooming-dropshipping-business",bullets:["Fast-growing","Loyal buyers","Brand-ready"]},
  {id:"ds-009",name:"Beauty & Makeup Store",short:"Beauty & Makeup",cat:"dropshipping",price:99,handle:"beauty-makeup-dropshipping-business-for-sale",bullets:["Cosmetics niche","Viral potential","Influencer-friendly"]},
  {id:"ds-010",name:"Home & Garden Store",short:"Home & Garden",cat:"dropshipping",price:99,handle:"home-garden-dropshipping-business-for-sale",bullets:["Evergreen niche","Wide catalog","High repeat"]},
  {id:"ds-011",name:"Women's Swimwear Store",short:"Swimwear",cat:"dropshipping",price:99,handle:"womens-swimwear-dropshipping-business",bullets:["Seasonal spikes","Visual niche","Social ads ready"]},
  {id:"ds-012",name:"Medical Supplies Store",short:"Medical Supplies",cat:"dropshipping",price:99,handle:"medical-supplies-dropshipping-business",bullets:["Healthcare niche","Steady demand","B2B potential"]},
  {id:"ds-013",name:"Organic Wellness Store",short:"Organic Wellness",cat:"dropshipping",price:99,handle:"buy-premium-organic-food-health-beauty-store",bullets:["Premium pricing","Health buyers","Subscription potential"]},
  {id:"ds-014",name:"Sunglass & Watch Store",short:"Sunglasses+Watches",cat:"dropshipping",price:99,handle:"wooden-sunglasses-watches-dropshipping-store",bullets:["Fashion accessories","Gift market","High margins"]},
  {id:"ds-015",name:"Specialty Coffee Store",short:"Specialty Coffee",cat:"dropshipping",price:99,handle:"specialty-coffee-dropshipping-business",bullets:["Subscription niche","Passionate buyers","Brand building"]},
  {id:"ds-016",name:"Kids Fashion Store",short:"Kids Fashion",cat:"dropshipping",price:99,handle:"kids-fashion-dropshipping-business-for-sale",bullets:["Parent buyers","Gift occasions","Repeat purchases"]},
  {id:"ds-017",name:"Home Decor & Furniture Store",short:"Home Decor",cat:"dropshipping",price:99,handle:"buy-home-decor-store-1",bullets:["High AOV","Pinterest traffic","Interior niche"]},
  {id:"ds-018",name:"Men's Lifestyle Store",short:"Men's Lifestyle",cat:"dropshipping",price:99,handle:"mens-lifestyle-dropshipping-business",bullets:["Broad male niche","Multiple categories","Strong ads"]},
  {id:"ds-019",name:"Jewelry & Accessories Store",short:"Jewelry",cat:"dropshipping",price:99,handle:"jewelry-dropshipping-business-for-sale",bullets:["Gift market","High margins","Evergreen"]},
  {id:"ds-020",name:"Leggings & Activewear Store",short:"Activewear",cat:"dropshipping",price:99,handle:"leggings-dropshipping-business-for-sale",bullets:["Fitness lifestyle","TikTok friendly","Repeat buyers"]},
  {id:"ds-021",name:"Travel Accessories Store",short:"Travel Accessories",cat:"dropshipping",price:99,handle:"travel-accessories-dropshipping-business",bullets:["Travel niche","Gift market","Seasonal upside"]},
  {id:"ds-022",name:"Backpack & Travel Bags Store",short:"Travel Bags",cat:"dropshipping",price:99,handle:"backpack-dropshipping-business-for-sale",bullets:["Student market","Back-to-school","High volume"]},
  {id:"ds-023",name:"Video Gaming Store",short:"Video Gaming",cat:"dropshipping",price:99,handle:"video-gaming-dropshipping-business",bullets:["Passionate niche","Year-round demand","Merch potential"]},
  {id:"ds-024",name:"Perfume & Cosmetics Store",short:"Perfume Store",cat:"dropshipping",price:99,handle:"perfume-cosmetics-dropshipping-business",bullets:["Luxury feel","Gift buyers","High repeat"]},
  {id:"ds-025",name:"Handbag & Accessories Store",short:"Handbags",cat:"dropshipping",price:99,handle:"handbag-dropshipping-business-for-sale",bullets:["Women's fashion","Gift market","High margins"]},
  {id:"ds-026",name:"Urban Streetwear Store",short:"Streetwear",cat:"dropshipping",price:99,handle:"streetwear-dropshipping-business-for-sale",bullets:["Youth culture","Brand identity","Social-first"]},
  {id:"ds-027",name:"Camping & Outdoor Gear Store",short:"Camping & Outdoor",cat:"dropshipping",price:99,handle:"outdoor-camping-dropshipping-business",bullets:["Outdoor enthusiasts","High AOV","Seasonal peaks"]},
  {id:"ds-028",name:"Watches & Accessories Store",short:"Watches",cat:"dropshipping",price:99,handle:"watches-sunglasses-dropshipping-business",bullets:["Luxury positioning","Gift market","High margins"]},
  {id:"ds-029",name:"Lingerie & Intimates Store",short:"Lingerie",cat:"dropshipping",price:99,handle:"lingerie-dropshipping-business-for-sale",bullets:["Recurring buyers","Gift occasions","Strong AOV"]},
  {id:"ds-030",name:"Men's Shoes Store",short:"Men's Shoes",cat:"dropshipping",price:99,handle:"mens-shoes-dropshipping-business-for-sale",bullets:["Fashion footwear","Broad appeal","High search"]},
  {id:"ds-031",name:"Men's Fashion Store",short:"Men's Fashion",cat:"dropshipping",price:99,handle:"mens-fashion-dropshipping-business-for-sale",bullets:["Full menswear","Influencer-friendly","Strong margins"]},
  {id:"ds-032",name:"Gadgets Store",short:"Gadgets",cat:"dropshipping",price:99,handle:"gadgets-dropshipping-business-for-sale",bullets:["Impulse buys","Viral potential","Gift market"]},
  {id:"ds-033",name:"Hip Hop & Streetwear Store",short:"Hip Hop Wear",cat:"dropshipping",price:99,handle:"hip-hop-streetwear-dropshipping-business",bullets:["Cultural niche","Passionate community","Social-first"]},
  {id:"ds-034",name:"Sneakers & Shoes Store",short:"Sneakers",cat:"dropshipping",price:99,handle:"sneakers-shoes-dropshipping-business-for-sale",bullets:["Sneakerhead culture","High demand","Repeat buyers"]},
  {id:"amz-001",name:"Amazon Organic Beauty Store",short:"Organic Beauty",cat:"amazon",price:99,handle:"amazon-organic-health-beauty-fba-business",bullets:["Beauty niche","Affiliate ready","Content included"]},
  {id:"amz-002",name:"Amazon Electronics Store",short:"Amazon Electronics",cat:"amazon",price:99,handle:"amazon-electronics-fba-business",bullets:["High commissions","Tech reviews","SEO content"]},
  {id:"amz-003",name:"Amazon Pharmacy Store",short:"Amazon Pharmacy",cat:"amazon",price:99,handle:"buy-amazon-pharmacy-store",bullets:["Health niche","Steady demand","Trusted category"]},
  {id:"amz-004",name:"Amazon Health & Fitness Store",short:"Amazon Health",cat:"amazon",price:99,handle:"amazon-health-fitness-fba-business",bullets:["Evergreen niche","High volume","Commission ready"]},
  {id:"amz-005",name:"Amazon Apple Accessories Store",short:"Apple Accessories",cat:"amazon",price:99,handle:"buy-amazon-apple-accessories-business",bullets:["Apple ecosystem","Loyal buyers","High intent"]},
  {id:"amz-006",name:"Amazon Grocery Store",short:"Amazon Grocery",cat:"amazon",price:99,handle:"amazon-grocery-fba-business-for-sale",bullets:["Repeat purchases","Pantry staples","Subscription"]},
  {id:"amz-007",name:"Amazon Pet Store",short:"Amazon Pets",cat:"amazon",price:99,handle:"amazon-pet-supplies-fba-business",bullets:["Pet owner market","Loyal niche","High LTV"]},
  {id:"amz-008",name:"Amazon Toys Store",short:"Amazon Toys",cat:"amazon",price:99,handle:"buy-amazon-fba-toys-games-store",bullets:["Gift occasions","Seasonal spikes","Family market"]},
  {id:"amz-009",name:"Amazon Sneaker Store",short:"Amazon Sneakers",cat:"amazon",price:99,handle:"buy-amazon-fba-sneakers-footwear-store",bullets:["Footwear niche","High commissions","Trend-driven"]},
  {id:"amz-010",name:"Amazon Home Decor Store",short:"Amazon Home Decor",cat:"amazon",price:99,handle:"amazon-home-decor-furniture-fba-business",bullets:["Interior niche","Pinterest traffic","High AOV"]},
  {id:"amz-011",name:"Amazon Auto Accessories Store",short:"Amazon Auto",cat:"amazon",price:99,handle:"amazon-auto-accessories-fba-business",bullets:["Car enthusiasts","High intent","Broad market"]},
  {id:"amz-012",name:"Amazon Makeup Store",short:"Amazon Makeup",cat:"amazon",price:99,handle:"buy-amazon-fba-beauty-makeup-store",bullets:["Beauty community","Tutorial traffic","Repeat buyers"]},
  {id:"amz-013",name:"Amazon Coffee Store",short:"Amazon Coffee",cat:"amazon",price:99,handle:"amazon-coffee-fba-business-for-sale",bullets:["Passionate niche","Subscription buyers","Daily habit"]},
  {id:"ag-001",name:"AI Automation Agency",short:"AI Automation",cat:"agency",price:99,handle:"ai-agency-business-for-sale",bullets:["AI-powered","B2B clients","Recurring revenue"]},
  {id:"ag-002",name:"Video Production Agency",short:"Video Production",cat:"agency",price:99,handle:"buy-premium-video-production-agency",bullets:["Done-for-you","Delivery team","B2B ready"]},
  {id:"ag-003",name:"Virtual Assistant Agency",short:"VA Agency",cat:"agency",price:99,handle:"buy-personal-assistant-agency",bullets:["Drop servicing","VA network","Low overhead"]},
  {id:"ag-004",name:"Digital Marketing Agency",short:"Digital Marketing",cat:"agency",price:99,handle:"digital-marketing-agency-business-for-sale",bullets:["Full-service","Client portal","Retainer model"]},
  {id:"ag-005",name:"Content Writing Agency",short:"Content Writing",cat:"agency",price:99,handle:"content-writing-agency-business-for-sale",bullets:["Writer network","SEO content","Monthly retainers"]},
  {id:"ag-006",name:"Facebook Ads Agency",short:"Facebook Ads",cat:"agency",price:99,handle:"facebook-ads-agency-business-for-sale",bullets:["Paid ads","Client management","Proven templates"]},
  {id:"ag-007",name:"Web Design Agency",short:"Web Design",cat:"agency",price:99,handle:"buy-website-design-development-agency",bullets:["Design team","Portfolio included","Recurring revenue"]},
  {id:"ag-008",name:"Lead Generation Agency",short:"Lead Generation",cat:"agency",price:99,handle:"lead-generation-agency-business-for-sale",bullets:["High-demand","Outreach system","B2B focused"]},
  {id:"ag-009",name:"SEO Agency",short:"SEO Agency",cat:"agency",price:99,handle:"seo-agency-business-for-sale",bullets:["Done-for-you SEO","Client dashboard","Monthly retainers"]},
  {id:"app-001",name:"White-Label Booking App",short:"Booking App",cat:"app",price:99,handle:"buy-booking-app",bullets:["Full source code","Resell rights","SaaS model"]},
  {id:"app-002",name:"White-Label Job Board App",short:"Job Board App",cat:"app",price:99,handle:"justjobs-whitelabel-job-board-recruitment-platform",bullets:["Recruitment niche","White-label","Monetizable"]},
  {id:"app-003",name:"Stride — Habit Tracker App",short:"Habit Tracker",cat:"app",price:99,handle:"stride-whitelabel-habit-goal-tracker-app",bullets:["Productivity niche","Mobile-ready","Resell rights"]},
  {id:"app-004",name:"Auto Marketing — AI App",short:"AI Marketing App",cat:"app",price:99,handle:"automarketing-white-label-ai-marketing-agent",bullets:["AI-powered","Marketing automation","SaaS model"]},
  {id:"app-005",name:"Client Folio — Pocket CRM",short:"Pocket CRM",cat:"app",price:99,handle:"clientfolio-whitelabel-pocket-crm-for-pros",bullets:["CRM for freelancers","Client management","Full source"]},
  {id:"app-006",name:"QR Hero — QR Code Generator",short:"QR Code App",cat:"app",price:99,handle:"qr-hero",bullets:["Utility app","B2B market","White-label"]},
  {id:"app-007",name:"Star Magnet — Review App",short:"Review App",cat:"app",price:99,handle:"star-magnet-whitelabel-review-reputation-app",bullets:["Local business","Reputation mgmt","Recurring"]},
  {id:"app-008",name:"Invoice Hero — Invoice Generator",short:"Invoice App",cat:"app",price:99,handle:"invoice-hero-white-label-quick-invoice-generator-app",bullets:["Freelancer tool","High demand","Monetizable"]},
  {id:"app-009",name:"Bio Wise — Link-in-Bio Builder",short:"Link-in-Bio App",cat:"app",price:99,handle:"bio-wise-link-in-bio-page-builder-app",bullets:["Creator economy","Social tool","Subscription"]},
  {id:"app-010",name:"Save Wise — Expense Tracker",short:"Expense Tracker",cat:"app",price:99,handle:"sample-store",bullets:["Finance niche","Mass market","Full source"]},
  {id:"app-011",name:"HeroCV — AI Resume Builder",short:"AI Resume App",cat:"app",price:99,handle:"herocv-white-label-ai-resume-cover-letter-builder",bullets:["AI-powered","Job seekers","High demand"]},
];

const BUNDLE_PRICING = { 1: null, 2: 149, 3: 199 };
const PROMO_CODES = { "CHIEF10": 10, "LAUNCH20": 20, "BUNDLE15": 15 };
const AFFINITY_MAP = { dropshipping: ["agency","app"], amazon: ["app","dropshipping"], agency: ["app","amazon"], app: ["agency","dropshipping"] };
const ARCHETYPES = { solopreneur: ["ds-005","amz-007","app-009"], agency: ["ag-001","ag-004","app-004"], passive: ["amz-001","amz-010","app-007"] };
const CAT_LABEL = { dropshipping: "Dropshipping", amazon: "Amazon FBA", agency: "Digital Agency", app: "Ready-Made App" };

let cart = [], activeFilter = "all", promoApplied = null, aiDismissed = false;

// ── PRICING HELPERS ────────────────────────────────────────
function bundlePrice() {
  const n = cart.length;
  if (n === 0) return 0;
  if (n === 1) return cart[0].price;
  if (n === 2) return 149;
  return 199;
}
function finalPrice() {
  const b = bundlePrice();
  if (!promoApplied) return b;
  return Math.round(b * (1 - promoApplied.pct / 100));
}
function fmt(n) { return "$" + Number(n).toLocaleString(); }

// ── CART ACTIONS ─────────────────────────────────────────
function addToCart(id) {
  if (cart.find(c => c.id === id)) return;
  const p = PRODUCTS.find(x => x.id === id);
  if (!p) return;
  cart.push(p);
  update();
  pulseSidebar();
}
function removeFromCart(id) {
  cart = cart.filter(c => c.id !== id);
  update();
}
function toggleCart(id) {
  if (cart.find(c => c.id === id)) removeFromCart(id);
  else addToCart(id);
}
function pulseSidebar() {
  const c = document.getElementById("ec-cart-card");
  if (!c) return;
  c.style.transition = "transform 0.2s cubic-bezier(0.34,1.56,0.64,1)";
  c.style.transform = "scale(1.025)";
  setTimeout(() => { c.style.transform = "scale(1)"; }, 220);
}

// ── CSS INJECTION ─────────────────────────────────────────
function injectStyles() {
  if (document.getElementById("ec-bb-styles-v2")) return;
  const css = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,300&family=DM+Serif+Display:ital@0;1&display=swap');
#ec-bb-v2,#ec-bb-v2 *{box-sizing:border-box;}
#ec-bb-v2{
  --navy:#0d1b2a;--blue:#2563eb;--blue-l:#eff6ff;--blue-m:#93c5fd;
  --green:#10b981;--green-l:#ecfdf5;--amber:#f59e0b;--amber-l:#fffbeb;
  --red:#ef4444;--g50:#f9fafb;--g100:#f3f4f6;--g200:#e5e7eb;
  --g400:#9ca3af;--g500:#6b7280;--g700:#374151;--g900:#111827;
  --white:#ffffff;
  --ff:'DM Sans',Helvetica,sans-serif;
  --ffd:'DM Serif Display',Georgia,serif;
  --ease-s:cubic-bezier(0.34,1.56,0.64,1);
  --ease-o:cubic-bezier(0.16,1,0.3,1);
  font-family:var(--ff);color:var(--g900);
  -webkit-font-smoothing:antialiased;
  background:#f7f8fc;
  margin:0 -40px;
}
/* HERO */
.ec-hero{background:var(--navy);padding:52px 40px 48px;position:relative;overflow:hidden;border-radius:0 0 28px 28px;margin-bottom:28px;}
.ec-hero::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 60% 80% at 80% 50%,rgba(37,99,235,0.18) 0%,transparent 70%),radial-gradient(ellipse 40% 60% at 10% 80%,rgba(16,185,129,0.1) 0%,transparent 60%);pointer-events:none;}
.ec-hero-dots{position:absolute;inset:0;background-image:radial-gradient(rgba(255,255,255,0.06) 1px,transparent 1px);background-size:28px 28px;pointer-events:none;}
.ec-hero-inner{max-width:1100px;margin:0 auto;position:relative;z-index:1;}
.ec-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.15);border-radius:999px;padding:7px 16px;font-size:12px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;color:rgba(255,255,255,0.8);margin-bottom:20px;}
.ec-hero-badge-dot{width:7px;height:7px;border-radius:50%;background:var(--green);box-shadow:0 0 8px var(--green);animation:ec-pulse 2s ease-in-out infinite;}
@keyframes ec-pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.7;transform:scale(1.35)}}
.ec-hero h1{font-family:var(--ffd);font-size:clamp(30px,4.5vw,54px);font-weight:400;line-height:1.08;color:var(--white);margin:0 0 14px;letter-spacing:-.02em;}
.ec-hero h1 em{font-style:italic;color:transparent;-webkit-text-stroke:1.5px rgba(255,255,255,0.5);}
.ec-hero-sub{font-size:16px;color:rgba(255,255,255,0.6);font-weight:400;line-height:1.65;max-width:540px;margin:0 0 30px;}
.ec-hero-pricing{display:flex;gap:10px;flex-wrap:wrap;align-items:center;}
.ec-hero-pill{display:flex;align-items:center;background:rgba(255,255,255,0.07);border:1px solid rgba(255,255,255,0.12);border-radius:12px;padding:12px 18px;transition:all .2s ease;}
.ec-hp-lbl{font-size:10px;color:rgba(255,255,255,.5);font-weight:700;letter-spacing:.06em;text-transform:uppercase;display:block;margin-bottom:3px;}
.ec-hp-val{font-size:22px;font-weight:800;color:var(--white);line-height:1;}
.ec-hp-val--blue{color:#93c5fd;}
.ec-hp-val--green{color:var(--green);}
.ec-hero-arrow{color:rgba(255,255,255,.2);font-size:20px;font-weight:300;}
.ec-hero-save{background:rgba(16,185,129,.15);border:1px solid rgba(16,185,129,.3);border-radius:10px;padding:10px 14px;}
.ec-hero-save span:first-child{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:var(--green);display:block;margin-bottom:2px;}
.ec-hero-save span:last-child{font-size:13px;font-weight:700;color:rgba(255,255,255,.85);}

/* TIER */
.ec-tier{max-width:1100px;margin:0 auto 26px;padding:0 20px;}
.ec-tier-card{background:var(--white);border:1px solid var(--g200);border-radius:18px;padding:18px 24px;display:flex;align-items:center;gap:22px;box-shadow:0 2px 16px rgba(13,27,42,.06);flex-wrap:wrap;}
.ec-tier-left{flex:1;min-width:180px;}
.ec-tier-msg{font-size:13px;font-weight:600;color:var(--g900);margin-bottom:9px;transition:all .3s ease;}
.ec-tier-track{height:5px;background:var(--g100);border-radius:3px;overflow:hidden;}
.ec-tier-fill{height:100%;border-radius:3px;background:linear-gradient(90deg,var(--blue),#60a5fa);transition:width .6s var(--ease-s);}
.ec-tier-steps{display:flex;gap:7px;flex-shrink:0;}
.ec-ts{text-align:center;padding:8px 14px;border-radius:10px;border:1.5px solid var(--g200);background:var(--white);transition:all .25s ease;min-width:76px;}
.ec-ts-n{font-size:10px;color:var(--g400);font-weight:700;margin-bottom:2px;text-transform:uppercase;letter-spacing:.04em;}
.ec-ts-p{font-size:14px;font-weight:800;color:var(--g700);}
.ec-ts--active{border-color:var(--blue);background:var(--blue-l);}
.ec-ts--active .ec-ts-n{color:var(--blue);}
.ec-ts--active .ec-ts-p{color:var(--blue);}
.ec-ts--done{border-color:var(--green);background:var(--green-l);}
.ec-ts--done .ec-ts-n{color:var(--green);}
.ec-ts--done .ec-ts-p{color:var(--green);}

/* BODY */
.ec-body{max-width:1100px;margin:0 auto 60px;padding:0 20px;display:grid;grid-template-columns:1fr 308px;gap:22px;align-items:start;}

/* ARCHETYPES */
.ec-archetypes{margin-bottom:22px;}
.ec-arch-lbl{font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--g400);margin-bottom:11px;}
.ec-arch-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:9px;}
.ec-arch-card{background:var(--white);border:1.5px solid var(--g200);border-radius:14px;padding:14px;cursor:pointer;transition:all .25s var(--ease-o);position:relative;overflow:hidden;}
.ec-arch-card:hover{border-color:var(--blue);transform:translateY(-2px);box-shadow:0 8px 24px rgba(37,99,235,.1);}
.ec-arch-icon{font-size:22px;margin-bottom:8px;display:block;}
.ec-arch-name{font-size:13px;font-weight:700;color:var(--g900);margin-bottom:3px;}
.ec-arch-desc{font-size:11px;color:var(--g500);line-height:1.5;}
.ec-arch-badge{position:absolute;top:9px;right:9px;font-size:10px;font-weight:700;background:var(--blue-l);color:var(--blue);border-radius:6px;padding:2px 7px;}

/* FILTERS */
.ec-filters{display:flex;gap:7px;flex-wrap:wrap;margin-bottom:18px;}
.ec-filter{display:flex;align-items:center;gap:6px;padding:8px 16px;border-radius:999px;border:1.5px solid var(--g200);background:var(--white);font-family:var(--ff);font-size:13px;font-weight:600;color:var(--g500);cursor:pointer;transition:all .2s var(--ease-o);white-space:nowrap;}
.ec-filter:hover{border-color:var(--g400);color:var(--g900);}
.ec-filter--active{background:var(--navy);border-color:var(--navy);color:var(--white);}
.ec-filter-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0;}

/* AI STRIP */
.ec-ai-strip{display:none;background:linear-gradient(135deg,#fffbeb,#fef3c7);border:1px solid #fde68a;border-radius:14px;padding:13px 16px;margin-bottom:16px;animation:ec-slide-in .3s var(--ease-o);}
@keyframes ec-slide-in{from{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:translateY(0)}}
.ec-ai-inner{display:flex;align-items:center;gap:9px;flex-wrap:wrap;}
.ec-ai-lbl{font-size:12px;font-weight:700;color:#92400e;white-space:nowrap;}
.ec-ai-chips{display:flex;gap:6px;flex-wrap:wrap;flex:1;}
.ec-ai-chip{font-size:12px;font-weight:600;padding:5px 12px;border-radius:999px;border:1.5px solid #f59e0b;background:var(--white);color:#92400e;cursor:pointer;font-family:var(--ff);transition:all .2s ease;}
.ec-ai-chip:hover{background:#f59e0b;color:var(--white);}
.ec-ai-close{background:none;border:none;cursor:pointer;font-size:17px;color:#b45309;padding:0 3px;line-height:1;flex-shrink:0;}

/* GRID */
.ec-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(188px,1fr));gap:11px;}
.ec-pcard{background:var(--white);border:1.5px solid var(--g200);border-radius:16px;padding:15px;cursor:pointer;transition:all .25s var(--ease-o);position:relative;display:flex;flex-direction:column;overflow:hidden;}
.ec-pcard:hover{border-color:var(--blue);transform:translateY(-3px);box-shadow:0 10px 30px rgba(37,99,235,.1);}
.ec-pcard--added{border-color:var(--green)!important;background:linear-gradient(135deg,#f0fdf4,var(--white))!important;box-shadow:0 0 0 3px rgba(16,185,129,.12)!important;transform:translateY(-3px)!important;}
.ec-pcard-check{position:absolute;top:11px;right:11px;width:20px;height:20px;border-radius:50%;background:var(--green);display:flex;align-items:center;justify-content:center;opacity:0;transform:scale(.4);transition:all .3s var(--ease-s);box-shadow:0 2px 8px rgba(16,185,129,.4);}
.ec-pcard--added .ec-pcard-check{opacity:1;transform:scale(1);}
.ec-pcard-check svg{width:10px;height:10px;}
.ec-cat-badge{display:inline-flex;align-items:center;gap:4px;font-size:10px;font-weight:700;padding:3px 8px;border-radius:6px;margin-bottom:9px;letter-spacing:.04em;text-transform:uppercase;width:fit-content;}
.ec-cat-ds{background:#eff6ff;color:#1d4ed8;border:1px solid #bfdbfe;}
.ec-cat-amz{background:#fffbeb;color:#b45309;border:1px solid #fde68a;}
.ec-cat-ag{background:#f0fdf4;color:#15803d;border:1px solid #bbf7d0;}
.ec-cat-app{background:#faf5ff;color:#7c3aed;border:1px solid #ddd6fe;}
.ec-dot-ds{background:#2563eb;}
.ec-dot-amz{background:#f59e0b;}
.ec-dot-ag{background:#10b981;}
.ec-dot-app{background:#7c3aed;}
.ec-pcard-name{font-size:13px;font-weight:700;color:var(--g900);margin-bottom:7px;line-height:1.35;flex:1;}
.ec-pcard-bullets{list-style:none;margin:0 0 11px;padding:0;}
.ec-pcard-bullets li{font-size:11px;color:var(--g500);line-height:1.6;padding-left:12px;position:relative;}
.ec-pcard-bullets li::before{content:'✓';position:absolute;left:0;color:var(--green);font-weight:700;font-size:10px;}
.ec-pcard-foot{display:flex;align-items:center;justify-content:space-between;margin-top:auto;}
.ec-pcard-price{font-size:16px;font-weight:800;color:var(--g900);}
.ec-add-btn{font-size:11px;font-weight:700;padding:7px 12px;border-radius:8px;border:1.5px solid var(--blue);background:var(--blue);color:var(--white);cursor:pointer;font-family:var(--ff);transition:all .2s ease;white-space:nowrap;line-height:1;}
.ec-add-btn:hover{background:#1d4ed8;border-color:#1d4ed8;}
.ec-add-btn--added{background:var(--green);border-color:var(--green);}
.ec-add-btn--added:hover{background:#059669;border-color:#059669;}

/* SIDEBAR */
.ec-sidebar-sticky{position:sticky;top:24px;}
.ec-cart-card{background:var(--white);border:1px solid var(--g200);border-radius:22px;box-shadow:0 4px 32px rgba(13,27,42,.08);overflow:hidden;transition:transform .2s var(--ease-s);}
.ec-cart-hdr{background:var(--navy);padding:18px 20px 15px;}
.ec-cart-title{font-size:14px;font-weight:700;color:var(--white);display:flex;align-items:center;justify-content:space-between;margin-bottom:3px;}
.ec-cart-count{font-size:11px;font-weight:600;background:rgba(255,255,255,.15);border-radius:999px;padding:2px 10px;color:var(--white);transition:all .3s var(--ease-s);}
.ec-cart-sub{font-size:11px;color:rgba(255,255,255,.45);}
.ec-cart-body{padding:16px 20px;}
.ec-empty{text-align:center;padding:22px 10px 8px;}
.ec-empty-icon{width:48px;height:48px;border-radius:14px;background:var(--g100);display:flex;align-items:center;justify-content:center;margin:0 auto 11px;font-size:22px;}
.ec-empty p{font-size:13px;color:var(--g500);line-height:1.5;}
.ec-cart-items{margin-bottom:13px;}
.ec-ci{display:flex;align-items:center;gap:7px;padding:7px 0;border-bottom:1px solid var(--g100);animation:ec-item-in .3s var(--ease-s);}
@keyframes ec-item-in{from{opacity:0;transform:translateX(10px)}to{opacity:1;transform:translateX(0)}}
.ec-ci-dot{width:7px;height:7px;border-radius:50%;flex-shrink:0;}
.ec-ci-name{flex:1;font-size:12px;font-weight:600;color:var(--g700);line-height:1.3;}
.ec-ci-price{font-size:12px;font-weight:700;color:var(--g900);white-space:nowrap;}
.ec-ci-del{background:none;border:none;cursor:pointer;color:var(--g300);font-size:16px;line-height:1;padding:0 2px;transition:color .15s ease;flex-shrink:0;}
.ec-ci-del:hover{color:var(--red);}
.ec-summary{margin-bottom:13px;}
.ec-srow{display:flex;justify-content:space-between;padding:3px 0;}
.ec-srow-l{font-size:12px;color:var(--g500);}
.ec-srow-v{font-size:12px;color:var(--g500);}
.ec-srow--save .ec-srow-l,.ec-srow--save .ec-srow-v{color:var(--green);font-weight:700;}
.ec-divider{height:1px;background:var(--g100);margin:9px 0;}
.ec-total-row{display:flex;justify-content:space-between;align-items:baseline;}
.ec-total-l{font-size:14px;font-weight:800;color:var(--g900);}
.ec-total-v{font-size:22px;font-weight:800;color:var(--navy);}
.ec-savings-badge{background:linear-gradient(135deg,var(--green-l),#d1fae5);border:1px solid #6ee7b7;border-radius:9px;padding:7px 11px;text-align:center;font-size:12px;font-weight:700;color:#065f46;margin-bottom:13px;animation:ec-badge-in .4s var(--ease-s);}
@keyframes ec-badge-in{from{opacity:0;transform:scale(.9)}to{opacity:1;transform:scale(1)}}
.ec-nudge{background:var(--amber-l);border:1px solid #fde68a;border-radius:9px;padding:9px 11px;font-size:12px;color:#92400e;line-height:1.5;margin-bottom:13px;display:none;}
.ec-promo{display:none;gap:6px;margin-bottom:5px;align-items:stretch;}
.ec-promo-input{flex:1;font-size:12px;padding:8px 11px;border:1.5px solid var(--g200);border-radius:8px;color:var(--g900);font-family:var(--ff);outline:none;transition:border-color .2s ease;background:var(--g50);}
.ec-promo-input:focus{border-color:var(--blue);}
.ec-promo-input::placeholder{color:var(--g400);}
.ec-promo-apply{font-size:12px;font-weight:700;padding:8px 13px;border-radius:8px;border:1.5px solid var(--g200);background:var(--white);color:var(--g700);cursor:pointer;font-family:var(--ff);transition:all .2s ease;white-space:nowrap;}
.ec-promo-apply:hover{background:var(--g100);}
.ec-promo-msg{font-size:11px;min-height:14px;margin-bottom:7px;}
.ec-checkout-btn{width:100%;padding:14px;border-radius:12px;border:none;background:linear-gradient(135deg,#1d4ed8,var(--blue));color:var(--white);font-size:14px;font-weight:700;cursor:pointer;font-family:var(--ff);transition:all .2s var(--ease-o);letter-spacing:.01em;position:relative;overflow:hidden;}
.ec-checkout-btn:hover:not(:disabled){transform:translateY(-2px);box-shadow:0 8px 24px rgba(37,99,235,.35);}
.ec-checkout-btn:disabled{opacity:.35;cursor:not-allowed;transform:none;}
.ec-checkout-err{font-size:11px;color:var(--red);text-align:center;margin-top:5px;display:none;}
.ec-trust{display:flex;justify-content:center;gap:10px;flex-wrap:wrap;margin-top:11px;}
.ec-trust-item{font-size:10px;font-weight:600;color:var(--g400);display:flex;align-items:center;gap:3px;}

/* RESPONSIVE */
@media(max-width:960px){.ec-body{grid-template-columns:1fr;}.ec-sidebar-sticky{position:static;}}
@media(max-width:640px){
  .ec-hero{padding:36px 18px 38px;margin-bottom:18px;}
  #ec-bb-v2{margin:0 -20px;}
  .ec-tier{padding:0 12px;}
  .ec-body{padding:0 12px;}
  .ec-arch-grid{grid-template-columns:1fr 1fr;}
  .ec-grid{grid-template-columns:repeat(auto-fill,minmax(150px,1fr));}
}
`;
  const style = document.createElement("style");
  style.id = "ec-bb-styles-v2";
  style.textContent = css;
  document.head.appendChild(style);
}

// ── HTML TEMPLATE ─────────────────────────────────────────
function buildHTML() {
  return `
<div id="ec-bb-v2">
  <!-- HERO -->
  <div class="ec-hero">
    <div class="ec-hero-dots"></div>
    <div class="ec-hero-inner">
      <div class="ec-hero-badge"><span class="ec-hero-badge-dot"></span>Build Your Business Portfolio</div>
      <h1>Mix, match &amp; own<br>your <em>perfect</em> bundle.</h1>
      <p class="ec-hero-sub">Browse 60+ ready-made businesses. Pick any combination. One checkout — full ownership transferred in 24–48 hours.</p>
      <div class="ec-hero-pricing">
        <div class="ec-hero-pill"><div><span class="ec-hp-lbl">1 Business</span><span class="ec-hp-val">$99</span></div></div>
        <span class="ec-hero-arrow">→</span>
        <div class="ec-hero-pill"><div><span class="ec-hp-lbl">Any 2</span><span class="ec-hp-val ec-hp-val--blue">$149</span></div></div>
        <span class="ec-hero-arrow">→</span>
        <div class="ec-hero-pill"><div><span class="ec-hp-lbl">Any 3+</span><span class="ec-hp-val ec-hp-val--green">$199</span></div></div>
        <div class="ec-hero-save"><span>Best Value</span><span>Save up to $98</span></div>
      </div>
    </div>
  </div>

  <!-- TIER BAR -->
  <div class="ec-tier">
    <div class="ec-tier-card">
      <div class="ec-tier-left">
        <div class="ec-tier-msg" id="ec-tier-msg">Add your first business to begin building</div>
        <div class="ec-tier-track"><div class="ec-tier-fill" id="ec-tier-fill"></div></div>
      </div>
      <div class="ec-tier-steps">
        <div class="ec-ts" id="ec-ts-1"><div class="ec-ts-n">1 item</div><div class="ec-ts-p">$99</div></div>
        <div class="ec-ts" id="ec-ts-2"><div class="ec-ts-n">2 items</div><div class="ec-ts-p">$149</div></div>
        <div class="ec-ts" id="ec-ts-3"><div class="ec-ts-n">3+ items</div><div class="ec-ts-p">$199</div></div>
      </div>
    </div>
  </div>

  <!-- MAIN BODY -->
  <div class="ec-body">
    <div class="ec-left">

      <!-- ARCHETYPES -->
      <div class="ec-archetypes">
        <div class="ec-arch-lbl">⚡ Quick-start — load a curated bundle instantly</div>
        <div class="ec-arch-grid">
          <div class="ec-arch-card" onclick="EcomChiefBundle.loadArchetype('solopreneur')">
            <span class="ec-arch-icon">🚀</span>
            <div class="ec-arch-name">The Solopreneur</div>
            <div class="ec-arch-desc">Dropshipping + Amazon + App</div>
            <span class="ec-arch-badge">3 businesses</span>
          </div>
          <div class="ec-arch-card" onclick="EcomChiefBundle.loadArchetype('agency')">
            <span class="ec-arch-icon">🏢</span>
            <div class="ec-arch-name">The Agency Stack</div>
            <div class="ec-arch-desc">AI Agency + Marketing + SaaS</div>
            <span class="ec-arch-badge">3 businesses</span>
          </div>
          <div class="ec-arch-card" onclick="EcomChiefBundle.loadArchetype('passive')">
            <span class="ec-arch-icon">💰</span>
            <div class="ec-arch-name">Passive Income Build</div>
            <div class="ec-arch-desc">Amazon + Home Decor + Review App</div>
            <span class="ec-arch-badge">3 businesses</span>
          </div>
        </div>
      </div>

      <!-- FILTERS -->
      <div class="ec-filters" id="ec-filters">
        <button class="ec-filter ec-filter--active" data-cat="all">All <span style="font-size:11px;opacity:.6;font-weight:500;">(67)</span></button>
        <button class="ec-filter" data-cat="dropshipping"><span class="ec-filter-dot" style="background:#2563eb;"></span>Dropshipping</button>
        <button class="ec-filter" data-cat="amazon"><span class="ec-filter-dot" style="background:#f59e0b;"></span>Amazon FBA</button>
        <button class="ec-filter" data-cat="agency"><span class="ec-filter-dot" style="background:#10b981;"></span>Digital Agency</button>
        <button class="ec-filter" data-cat="app"><span class="ec-filter-dot" style="background:#7c3aed;"></span>Ready-Made Apps</button>
      </div>

      <!-- AI STRIP -->
      <div class="ec-ai-strip" id="ec-ai-strip">
        <div class="ec-ai-inner">
          <span class="ec-ai-lbl">✨ Pairs well with your bundle:</span>
          <div class="ec-ai-chips" id="ec-ai-chips"></div>
          <button class="ec-ai-close" onclick="EcomChiefBundle.dismissAI()">✕</button>
        </div>
      </div>

      <!-- PRODUCT GRID -->
      <div class="ec-grid" id="ec-grid"></div>
    </div>

    <!-- SIDEBAR -->
    <div class="ec-sidebar">
      <div class="ec-sidebar-sticky">
        <div class="ec-cart-card" id="ec-cart-card">
          <div class="ec-cart-hdr">
            <div class="ec-cart-title">Bundle summary <span class="ec-cart-count" id="ec-count">0 selected</span></div>
            <div class="ec-cart-sub">Your custom business portfolio</div>
          </div>
          <div class="ec-cart-body">
            <div class="ec-empty" id="ec-empty">
              <div class="ec-empty-icon">🛒</div>
              <p><strong>Nothing added yet.</strong><br>Select businesses from the grid to start building.</p>
            </div>
            <div class="ec-cart-items" id="ec-items" style="display:none"></div>
            <div class="ec-summary" id="ec-summary" style="display:none"></div>
            <div class="ec-savings-badge" id="ec-savings" style="display:none"></div>
            <div class="ec-nudge" id="ec-nudge"></div>
            <div class="ec-promo" id="ec-promo">
              <input type="text" class="ec-promo-input" id="ec-promo-input" placeholder="Promo code" autocomplete="off"/>
              <button class="ec-promo-apply" onclick="EcomChiefBundle.applyPromo()">Apply</button>
            </div>
            <p class="ec-promo-msg" id="ec-promo-msg"></p>
            <button class="ec-checkout-btn" id="ec-checkout" disabled onclick="EcomChiefBundle.checkout()">Proceed to Checkout →</button>
            <p class="ec-checkout-err" id="ec-err"></p>
            <div class="ec-trust">
              <span class="ec-trust-item">🔒 Secure</span>
              <span class="ec-trust-item">⚡ Instant delivery</span>
              <span class="ec-trust-item">✅ 30-day guarantee</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`;
}

// ── RENDER ────────────────────────────────────────────────
function renderGrid() {
  const grid = document.getElementById("ec-grid");
  if (!grid) return;
  const catClass = { dropshipping:"ec-cat-ds", amazon:"ec-cat-amz", agency:"ec-cat-ag", app:"ec-cat-app" };
  const dotClass = { dropshipping:"ec-dot-ds", amazon:"ec-dot-amz", agency:"ec-dot-ag", app:"ec-dot-app" };
  const list = activeFilter === "all" ? PRODUCTS : PRODUCTS.filter(p => p.cat === activeFilter);
  grid.innerHTML = list.map(p => {
    const inCart = !!cart.find(c => c.id === p.id);
    return `<div class="ec-pcard${inCart ? " ec-pcard--added" : ""}">
      <div class="ec-pcard-check"><svg viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
      <span class="ec-cat-badge ${catClass[p.cat]}">${CAT_LABEL[p.cat]}</span>
      <div class="ec-pcard-name">${p.name}</div>
      <ul class="ec-pcard-bullets">${p.bullets.map(b => `<li>${b}</li>`).join("")}</ul>
      <div class="ec-pcard-foot">
        <span class="ec-pcard-price">${fmt(p.price)}</span>
        <button class="ec-add-btn${inCart ? " ec-add-btn--added" : ""}" onclick="EcomChiefBundle.toggleCart('${p.id}')">${inCart ? "✓ Added" : "+ Add"}</button>
      </div>
    </div>`;
  }).join("");
}

function renderSidebar() {
  const empty = document.getElementById("ec-empty");
  const items = document.getElementById("ec-items");
  const summary = document.getElementById("ec-summary");
  const savings = document.getElementById("ec-savings");
  const nudge = document.getElementById("ec-nudge");
  const promo = document.getElementById("ec-promo");
  const btn = document.getElementById("ec-checkout");
  const count = document.getElementById("ec-count");
  if (!empty) return;
  count.textContent = cart.length === 0 ? "0 selected" : `${cart.length} selected`;
  if (cart.length === 0) {
    empty.style.display = "block"; items.style.display = "none";
    summary.style.display = "none"; savings.style.display = "none";
    nudge.style.display = "none"; promo.style.display = "none";
    btn.disabled = true; return;
  }
  empty.style.display = "none"; items.style.display = "block";
  summary.style.display = "block"; promo.style.display = "flex"; btn.disabled = false;
  const dotClass = { dropshipping:"ec-dot-ds", amazon:"ec-dot-amz", agency:"ec-dot-ag", app:"ec-dot-app" };
  items.innerHTML = cart.map(p => `
    <div class="ec-ci">
      <span class="ec-ci-dot ${dotClass[p.cat]}"></span>
      <span class="ec-ci-name">${p.short}</span>
      <span class="ec-ci-price">${fmt(p.price)}</span>
      <button class="ec-ci-del" onclick="EcomChiefBundle.removeFromCart('${p.id}')">×</button>
    </div>`).join("");
  const retail = cart.reduce((s, p) => s + p.price, 0);
  const bundle = bundlePrice();
  const bundleSave = retail - bundle;
  const promoSave = promoApplied ? Math.round(bundle * (promoApplied.pct / 100)) : 0;
  const total = finalPrice();
  let html = `<div class="ec-srow"><span class="ec-srow-l">Retail value</span><span class="ec-srow-v">${fmt(retail)}</span></div>`;
  if (bundleSave > 0) html += `<div class="ec-srow ec-srow--save"><span class="ec-srow-l">Bundle discount</span><span class="ec-srow-v">−${fmt(bundleSave)}</span></div>`;
  if (promoSave > 0) html += `<div class="ec-srow ec-srow--save"><span class="ec-srow-l">Promo: ${promoApplied.code}</span><span class="ec-srow-v">−${fmt(promoSave)}</span></div>`;
  html += `<div class="ec-divider"></div><div class="ec-total-row"><span class="ec-total-l">Total</span><span class="ec-total-v">${fmt(total)}</span></div>`;
  summary.innerHTML = html;
  const totalSaved = bundleSave + promoSave;
  if (totalSaved > 0) { savings.style.display = "block"; savings.textContent = `🎉 You're saving ${fmt(totalSaved)} total`; }
  else savings.style.display = "none";
  if (cart.length === 1) { nudge.style.display = "block"; nudge.innerHTML = `💡 Add <strong>1 more</strong> business — pay just <strong>$149</strong> for both instead of $198.`; }
  else if (cart.length === 2) { nudge.style.display = "block"; nudge.innerHTML = `💡 Add <strong>1 more</strong> — get all three for just <strong>$199</strong>. Best value!`; }
  else nudge.style.display = "none";
}

function renderTier() {
  const fill = document.getElementById("ec-tier-fill");
  const msg = document.getElementById("ec-tier-msg");
  if (!fill) return;
  const n = cart.length;
  fill.style.width = (Math.min(n / 3, 1) * 100) + "%";
  ["ec-ts-1","ec-ts-2","ec-ts-3"].forEach((id, i) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.className = "ec-ts";
    if (n > i + 1) el.classList.add("ec-ts--done");
    else if (n === i + 1 || (i === 2 && n >= 3)) el.classList.add("ec-ts--active");
  });
  if (n === 0) msg.textContent = "Add your first business to begin building";
  else if (n === 1) msg.textContent = "Great start! Add 1 more → unlock the $149 bundle price";
  else if (n === 2) msg.textContent = "2-business bundle — $149. Add 1 more → $199 for all three!";
  else msg.textContent = `${n} businesses selected — $199 flat. Best value! 🎉`;
}

function renderAI() {
  const strip = document.getElementById("ec-ai-strip");
  if (!strip || cart.length === 0 || aiDismissed) { if (strip) strip.style.display = "none"; return; }
  const addedCats = [...new Set(cart.map(p => p.cat))];
  const suggestCats = new Set();
  addedCats.forEach(c => (AFFINITY_MAP[c] || []).forEach(x => suggestCats.add(x)));
  addedCats.forEach(c => suggestCats.delete(c));
  const sugs = [];
  for (const cat of suggestCats) {
    const cands = PRODUCTS.filter(p => p.cat === cat && !cart.find(c => c.id === p.id));
    if (cands.length > 0) { sugs.push(cands[0]); if (sugs.length >= 3) break; }
  }
  if (sugs.length === 0) { strip.style.display = "none"; return; }
  strip.style.display = "block";
  document.getElementById("ec-ai-chips").innerHTML = sugs.map(p =>
    `<button class="ec-ai-chip" onclick="EcomChiefBundle.addToCart('${p.id}')">+ ${p.short}</button>`
  ).join("");
}

function update() { renderGrid(); renderSidebar(); renderTier(); renderAI(); }

// ── CHECKOUT ─────────────────────────────────────────────
async function proceedToCheckout() {
  if (cart.length === 0) return;
  const btn = document.getElementById("ec-checkout");
  const err = document.getElementById("ec-err");
  btn.textContent = "Preparing checkout…"; btn.disabled = true;
  if (err) err.style.display = "none";
  try {
    const resolved = [];
    for (const p of cart) {
      const res = await fetch(`/products/${p.handle}.js`);
      if (!res.ok) throw new Error(`Product not found: ${p.short} (${res.status})`);
      const data = await res.json();
      if (!data.variants || !data.variants.length) throw new Error(`No variants for: ${p.short}`);
      const avail = data.variants.filter(v => v.available !== false);
      const v = (avail.length ? avail : data.variants).reduce((m, x) => parseFloat(x.price) < parseFloat(m.price) ? x : m);
      resolved.push({ id: v.id, quantity: 1, properties: { _Bundle: "EcomChief Custom Bundle", "Items in bundle": String(cart.length) } });
    }
    await fetch("/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } });
    const addRes = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: resolved }) });
    if (!addRes.ok) { const t = await addRes.text(); throw new Error(`Cart add failed (${addRes.status}): ${t}`); }
    window.location.href = "/checkout" + (promoApplied ? `?discount=${encodeURIComponent(promoApplied.code)}` : "");
  } catch (e) {
    console.error("[EcomChief Bundle Builder]", e);
    btn.textContent = "Proceed to Checkout →"; btn.disabled = false;
    if (err) { err.textContent = "Error: " + e.message; err.style.display = "block"; }
  }
}

// ── INIT ─────────────────────────────────────────────────
function init() {
  const mount = document.getElementById("ecomchief-bundle-builder");
  if (!mount) { console.warn("[EcomChief Bundle Builder] Mount point #ecomchief-bundle-builder not found."); return; }
  injectStyles();
  mount.innerHTML = buildHTML();
  document.getElementById("ec-filters").addEventListener("click", e => {
    const btn = e.target.closest(".ec-filter");
    if (!btn) return;
    document.querySelectorAll(".ec-filter").forEach(b => b.classList.remove("ec-filter--active"));
    btn.classList.add("ec-filter--active");
    activeFilter = btn.dataset.cat;
    renderGrid();
  });
  update();
}

// ── PUBLIC API ────────────────────────────────────────────
window.EcomChiefBundle = {
  toggleCart,
  addToCart,
  removeFromCart,
  applyPromo() {
    const input = document.getElementById("ec-promo-input");
    const msg = document.getElementById("ec-promo-msg");
    const code = (input ? input.value.trim().toUpperCase() : "");
    const pct = PROMO_CODES[code];
    if (pct && !promoApplied) {
      promoApplied = { code, pct };
      if (msg) { msg.textContent = `✓ Code applied — ${pct}% extra off!`; msg.style.color = "#10b981"; }
      renderSidebar();
    } else if (promoApplied) {
      if (msg) { msg.textContent = "A code is already applied."; msg.style.color = "#f59e0b"; }
    } else {
      if (msg) { msg.textContent = "Invalid code. Try CHIEF10, LAUNCH20 or BUNDLE15."; msg.style.color = "#ef4444"; }
    }
  },
  checkout: proceedToCheckout,
  dismissAI() { aiDismissed = true; const s = document.getElementById("ec-ai-strip"); if (s) s.style.display = "none"; },
  loadArchetype(key) {
    const ids = { solopreneur: ["ds-005","amz-007","app-009"], agency: ["ag-001","ag-004","app-004"], passive: ["amz-001","amz-010","app-007"] }[key] || [];
    cart = [];
    ids.forEach(id => { const p = PRODUCTS.find(x => x.id === id); if (p) cart.push(p); });
    update();
    pulseSidebar();
    const grid = document.getElementById("ec-grid");
    if (grid) grid.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
else init();

})();